// extracted by mini-css-extract-plugin
export default {"box":"Footer_box__dEhGI","toolbar":"Footer_toolbar__r3YXc","icons":"Footer_icons__vFgv7","icon":"Footer_icon__ctCoM"};